/** In-universe copy for DAISY-authorized ledger members. */
export const DAISY_SEAL_TOOLTIP = 'DAISY-Sealed · Ledger-Cleared';

/** Hoof wax seal asset (modal badge). */
export const DAISY_SEAL_IMAGE = '/badges/daisy-seal.png?v=6';

export type AvatarHonorStyle = 'default' | 'daisy-seal' | 'yellowstone';

export function normalizeLedgerUsername(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_\-]/g, '');
}

export function resolveAvatarHonorStyle(
  normalizedUser: string,
  authorizedUsers: ReadonlySet<string>,
  yellowstoneUsers: ReadonlySet<string>,
): AvatarHonorStyle {
  if (yellowstoneUsers.has(normalizedUser)) return 'yellowstone';
  if (authorizedUsers.has(normalizedUser)) return 'daisy-seal';
  return 'default';
}

export function hasDaisySeal(
  username: string,
  authorizedUsers: ReadonlySet<string>,
  yellowstoneUsers: ReadonlySet<string>,
): boolean {
  const normalized = normalizeLedgerUsername(username);
  return authorizedUsers.has(normalized) && !yellowstoneUsers.has(normalized);
}
